<template>
  <div class="contract-manage">
    <banner clazz="contract-manage-banner" url="contractManage">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        <el-button class="banner-button" round @click="goRegister('hetongguanli-banner-tiyan')">申请体验</el-button>
      </template>
    </banner>
    <div class="contract-manage-section1">
      <div class="section1-content clearfix">
        <img class="section1-img fl" src="../../assets/img/contractManage/1peitu.png" alt="实现所有端到端合同的协作化"/>
        <div class="section1-misc fr">
          <h1 class="misc-title">实现所有端到端合同的协作化，无纸化和无缝化</h1>
          <div class="misc-divider"></div>
          <p class="misc-content">
            甄云合同管理，支持线下上传，线上多方协作编辑，简化日常搜索<br/>
            呈现合同实时数据，为所有用户提供从采购到法律到销售的可见性，<br/>
            将每份合同都变成一个强大的决策工具。
          </p>
        </div>
      </div>
    </div>
    <div class="contract-manage-section3">
      <div class="section3-content">
        <h1 class="section3-title">合同管理为何至关重要？</h1>
        <div class="section3-divider"></div>
        <div class="section3-main">
          <div class="section3-choose">
            <ul class="section3-ul clearfix">
              <li class="section3-li fl" v-for="(item, index) in section3Data" :key="index">
                <div>
                  <img v-lazy="item.src" :alt="item.title">
                </div>
                <p v-html="item.title.replace(/@/g, '<br/>')"></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="contract-manage-section4">
      <div class="section4-above"></div>
      <div class="section4-under"></div>
      <div class="section4-content">
        <h1 class="section4-title">甄云合同管理，将您的合同转换为动态商业工具和社交管理工具</h1>
        <div class="section4-divider"></div>
        <div class="section4-main">
          <el-tabs type="border-card" class="contract-manage-tab">
            <el-tab-pane>
              <div class="contract-manage-tabpane" slot="label">简化合同创建</div>
              <div class="main-region">
                <div class="contents-img">
                  <img src="../../assets/img/contractManage/1bg1.png" alt="简化合同创建"/>
                </div>
                <div class="contents-content">
                  <h1 class="contents-title">
                    甄云合同管理采用预先批准的条款库、模板和审批工作流，<br/>
                    帮助您创建标准化的合同
                  </h1>
                  <div class="contents-divider"></div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>使用引导式设计向导简化合同创建
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>支持线下自定义合同模板，上传至系统；支持多模板管理
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>支持合同模板、合同文本进行多用户在线协同编辑，并可控<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;制不同用户编辑权限
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>确保合同符合公司政策以及法律条款和条件
                  </div>
                  <hover-button text="申请试用" clazz="consult-button dib" :duration=0.5 @click.native="goTrial('hetongguanli-gongju-jianhua')"/>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <div class="contract-manage-tabpane" slot="label">增强可见性</div>
              <div class="main-region">
                <div class="contents-img">
                  <img src="../../assets/img/contractManage/2bg2.png" alt="增强可见性"/>
                </div>
                <div class="contents-content">
                  <h1 class="contents-title">
                    采用安全、可搜索的信息库，拥有完整的审计历史记录
                  </h1>
                  <div class="contents-divider"></div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>识别偏离标准的更改并分配所需的操作
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>通过丰富的搜索功能快速找到您需要的内容
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>使用工作区快速找到审查和批准等需要注意的项目
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>标签替换：创建合同时根据模板标签，自动替换合同条款关键<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;字段
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>通过社交协作和工作流简化审查周期
                  </div>
                  <hover-button text="申请试用" clazz="consult-button dib" :duration=0.5 @click.native="goTrial('hetongguanli-gongju-zengqiang')"/>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <div class="contract-manage-tabpane" slot="label">电子签章</div>
              <div class="main-region">
                <div class="contents-img">
                  <img src="../../assets/img/contractManage/3bg3.png" alt="电子签章"/>
                </div>
                <div class="contents-content">
                  <h1 class="contents-title">简单，可见，可审计</h1>
                  <div class="contents-divider"></div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>CA认证：在线验证企业信息三要素，申请CA证书；同时支持<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;自定义印章，进行多印章管理
                  </div>
                  <div class="contents-detail">
                    <span class="detail-bar"></span>电子签章：通过SRM申请CA认证，签署时调用电子签章进行<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;签署
                  </div>
                  <hover-button text="申请试用" clazz="consult-button dib" :duration=0.5 @click.native="goTrial('hetongguanli-gongju-qianzhang')"/>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'ContractManage',
  metaInfo () {
    return {
      title: this.$seo.contractmanage.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.contractmanage.keywords
      },
      {
        name: 'description',
        content: this.$seo.contractmanage.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      section3Data: [
        {
          title: '60％的公司诉讼与@合同纠纷有关',
          src: require('../../assets/img/contractManage/section3-1.png')
        },
        {
          title: '73％的受访者表示@“价格变动”@是常见的合同纠纷',
          src: require('../../assets/img/contractManage/section3-2.png')
        },
        {
          title: '12％至15％的合同在组织@中丢失或下落不明',
          src: require('../../assets/img/contractManage/section3-3.png')
        }
      ]
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    },
    // 申请
    goTrial (code) {
      this.openRegister(false, code)
    }
  },
  created () {
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/contractManage.scss";
</style>



// WEBPACK FOOTER //
// contractManage.vue?683c3838